import { takeEvery, put, select } from 'redux-saga/effects';

import { makeGetRequestDEPRECATED, makePostRequest, makePostRequestDEPRECATED } from 'tools/utilities/ajax';
import { ISubmitPayload, IFlowOptions, AddressDetails } from 'types';
import { leadSubmitGUID } from 'store/modules/app/constants';
import {
  TYPES, IApplyPromoCodeSuccess, IApplyPromoCodeFailure, IApplyPromoCode, ISignUpSubmitFailure, ISignUpSubmitSuccess,
} from './actions';

// eslint-disable-next-line import/no-cycle
import { getSignUpData } from './selectors';
import { transformSignUpPayload } from './transformSignUpPayload';
// eslint-disable-next-line import/no-cycle
import { getFlowOptions } from '../options/selectors';
// eslint-disable-next-line import/no-cycle
import { getAddressDetails } from '../address-lookup/selectors';
// eslint-disable-next-line import/no-cycle
import { getBearerToken } from '../utils/getBearerToken';

function* applyPromoCode(action: IApplyPromoCode) {
  const {
    promoCode,
  } = action.payload;

  try {
    // @NOTE New API isn't setup to validate discount/promotional codes so using our existing server until
    // an API is implemented
    // const bearerToken = yield select(getBearerToken);
    // const response = yield makeGetRequest('/api/Product/GetValidPromotions', {}, bearerToken);
    const promoCodeDiscount = yield makeGetRequestDEPRECATED(`/verify-discount-code/${promoCode}`);

    yield put<IApplyPromoCodeSuccess>({
      type: TYPES.APPLY_PROMO_CODE_SUCCESS,
      payload: {
        promoCodeDiscount,
      },
    });
  } catch (error) {
    // console.error('error', error.response);
    const {
      // status, // Could use status to drive our own error messages if needed
      data: {
        error: promoCodeError,
      },
    } = error.response;

    yield put<IApplyPromoCodeFailure>({
      type: TYPES.APPLY_PROMO_CODE_FAILURE,
      payload: {
        promoCodeError,
      },
    });
  }
}

function* signUpSubmit() {
  try {
    const payload: ISubmitPayload = yield select<typeof getSignUpData>(getSignUpData);
    const options: IFlowOptions = yield select(getFlowOptions);
    const addressDetails: AddressDetails = yield select(getAddressDetails);
    const bearerToken: string = yield select(getBearerToken);

    const transformedPayload = transformSignUpPayload({
      data: payload, options, requestId: leadSubmitGUID, addressDetails,
    });

    // console.log('🤔🤔🤔 transformedPayload', transformedPayload);
    yield makePostRequestDEPRECATED('/sign-up', transformedPayload);
    yield makePostRequest('/api/Lead/CreateLead', transformedPayload, bearerToken);

    yield put<ISignUpSubmitSuccess>({
      type: TYPES.SUBMIT_SUCCESS,
      payload: null,
    });
  } catch (error) {
    yield put<ISignUpSubmitFailure>({
      type: TYPES.SUBMIT_FAILURE,
      payload: {
        error: `Something went wrong, ${error}, ${Date.now()}`,
      },
    });
  }
}

export function* signUpSagas() {
  yield takeEvery(TYPES.APPLY_PROMO_CODE, applyPromoCode);
  yield takeEvery(TYPES.SUBMIT, signUpSubmit);
}
